import React, { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';

interface PrivateRouteProps {
  children: ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    if (window.parent !== window) {
      return null;
    }

    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  return children;
};

export default PrivateRoute;
